import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { IconLoaderService } from '@embraceit/components';
import { Store } from '@ngxs/store';
import { UserIdleService } from 'angular-user-idle';
import { Login } from 'planning-portal-library/src/lib/presentation/state/planning-portal-global-state/planning-portal-global.actions';
import { filter, map, Subscription } from 'rxjs';


@Component({
  selector: 'planning-portal-root',
  templateUrl: './app.component.html',
  styles: [],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {
  subscriptions: Subscription[] = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private router: Router,
    private store: Store,
    private cdr: ChangeDetectorRef,
    private userIdle: UserIdleService,
    private iconLoader: IconLoaderService
  ) {
    this.iconLoader.loadSprite(
      'https://saas-ui-assets.cubivue.com/assets/img/cubivue-icons.svg'
    );
  }

  ngOnInit(): void {
    this.setPageTitle();
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe();

    // Start watch when time is up and logout
    this.userIdle.onTimeout().subscribe(() => {
      this.store.dispatch(new Login(undefined));
      this.router.navigate(['/accounts/login']).then();
      this.userIdle.resetTimer();
    });
  }

  ngAfterViewChecked(): void {
    this.setAutocompleteOff();
  }

  private setAutocompleteOff(): void {
    document.querySelectorAll('.form-control').forEach((element) => {
      element.setAttribute('autocomplete', 'off');
    });
  }

  private setPageTitle(): void {
    const defaultPageTitle = 'Planning Portal';

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;

          if (!child) {
            return (
              this.activatedRoute.snapshot.data['title'] || defaultPageTitle
            );
          }

          while (child.firstChild) {
            child = child.firstChild;
          }

          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
        })
      )
      .subscribe((title: string) =>
        this.title.setTitle(`${title} - ${defaultPageTitle}`)
      );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
